import script from "./PaymentServicePolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentServicePolicy.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentServicePolicy.vue?vue&type=style&index=0&id=5b503ab5&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b503ab5"]])

export default __exports__